




































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* 以下画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { applicationFormModule } from '../store/modules/ApplicationForm';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class ApplicationAcceptCheck extends ApiAccessBase {
  // 拡張パネルの設定（検索条件）
  private searchPanel: number[] = [0];  //初期表示展開
  // 検索結果ヘッダの設定
  private headers = [{}];

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = '添付書類受付確認';
    this.setVariablecolsState(['check_app_accept']);
    const path: string = UketsukeConstants.CHECK_APP_ACEPT_PATH + '/' + applicationFormModule.GET_APP_TYPE + '/init/search/trader';
    this.apiAccess(path, Constants.API_METHOD_GET, false, false);
  }

  /**
   * 受理
   */
  private checkAppAccept() {
    this.createSendForm();
    applicationFormModule.checkApplicationAccept[0] = '1';
    this.syncRealFormToFormData(this.$refs.form);
    //applicationFormModule.setCheckAttachedFile(this.formData);
    //pathに通し番号（traderID）付与
    const path = UketsukeConstants.CHECK_APP_ACEPT_PATH + '/' + applicationFormModule.GET_APP_TYPE + '/update/jyuri/' + applicationFormModule.GET_TRADER_ID;
    // 登録処理
    this.apiAccess(path, Constants.API_METHOD_POST, false, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        router.push({name: UketsukeScreenName.CHECK_RESULT});
      }
    });
  }

  /**
   * 不受理
   */
  private checkAppUnaccept() {
    this.createSendForm();
    applicationFormModule.checkApplicationAccept[0] = '0';
    applicationFormModule.checkApplicationAccept[1] = this.formData['fujyuriRiyuu'];
    this.syncRealFormToFormData(this.$refs.form);
    //pathに通し番号（traderID）付与
    const path = UketsukeConstants.CHECK_APP_ACEPT_PATH + '/' + applicationFormModule.GET_APP_TYPE + '/update/fujyuri/' + applicationFormModule.GET_TRADER_ID;
    // 登録処理
    this.apiAccess(path, Constants.API_METHOD_POST, false, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        router.push({name: UketsukeScreenName.CHECK_RESULT});
      }
    });
  }

  /**
   * 排他ロック解除＆戻る（戻るボタンクリック）
   */
  private deleteExclusive() {
    this.apiAccess(UketsukeConstants.APP_TARDER_PATH + '/exclusive/delete/' + applicationFormModule.GET_TRADER_ID, Constants.API_METHOD_POST, false, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        applicationFormModule.moduleResetDetail();
        router.push({name: UketsukeScreenName.SEARCH_APPLICATION_TRADER});
      }
    });
  }
}
